export default __webpack_public_path__ + "static/martini-designer-22953a9873610c5a4d68d04958279357.png";